<!-- 公共底部的封装 -->
<template>
  <div class="footer" id="footer" ref="foot">
    <div class="bottom_border">
      <div class="bottom_center">
        <ul class>
          <li @click="handleJieSecond" class="foot_title">解决方案</li>
          <router-link
            tag="li"
            class="nav_li"
            :to="item.link"
            v-for="(item,index) in jieList"
            :key="index"
             @click.native="flushCom"
          >
            <span>{{item.name}}</span>
          </router-link>
        </ul>
        <ul>
          <li @click="handleChanSecond">产品中心</li>
          <li class="nav_li" v-for="(ite,index) in chanList" :key="index">
            <router-link tag="div" v-for="(it1,index) in ite.title" :key="index" :to="it1.link"  @click.native="flushCom">
              <span>{{it1.name}}</span>
            </router-link>
          </li>
        </ul>
        <ul class>
          <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
          <li @click="handleZiSecond">咨询服务</li>
          <li class="nav_li" :to="ite2.link" v-for="(ite2,index) in ziList" :key="index">
            <router-link
              tag="div"
              :to="it.link"
              v-for="(it,index) in ite2.detail"
              :key="index"
             
               @click.native="flushCom"
               class="zixun1"
            >
              <span>{{it.name}}</span>
            </router-link>
          </li>
        </ul>
        <ul class>
          <li @click="handleZhuanSecond"  class="zc" >专长</li>
          <li v-for="(item,index) in zhuanList" :key="index" @click="handleZhuan(index)">
            <span>{{item.name}}</span>
          </li>
        </ul>
        <ul class>
          <li @click="handleLiaoSecond">了解我们</li>
          <li v-for="(item,index) in liaoList" :key="index" @click="handleLiao(index)">
            <span>{{item.name}}</span>
          </li>
        </ul>
        <!-- <ul class="last_ul">
          <li>加入我们</li>
          <li v-for="(ite,index) in jiaList" :key="index">
            <span>{{ite.name}}</span>
          </li>
        </ul> -->
      </div>
    </div>
     <div class="contact">
            <div class="contact_center">
              <div class="font">联系方式</div>
              <div class="contact_phone">
                <div class="contact_phone1">
                  <img src="@assets/img/dianhua.png" alt />
                  <span class="phone1">0571-88331233</span>
                     <img class="chuanzhen" src="@assets/img/youxiang.png" alt />
                  <span  >310021</span>
               
                </div>
                <div class="contact_phone2">
                  <img class="chuanzhen" src="@assets/img/chuanzhen.png" alt />
                  <span class="phone2">0571-88331244</span>
                  <img class="dizhi" src="@assets/img/dizhi.png" alt />
                  <span>浙江省杭州市江干区天城路68号万事利科技大厦A座9层</span>
                </div>
              </div>
              <div class="image_er">
              <img :src="erweima" alt class="erweima" /></div>
            </div>
          </div>
    <div class="power">
      <span>版权所有： © 2019 谱恒高科技有限责任公司 <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#fff;">浙ICP备15043944号-1</a></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  inject: ["reload"],
  data() {
    return {
      jieList: [
        { name: "自动化", link: "automation" },
        { name: "物联", link: "iot" },
        { name: "能源", link: "energy" },
        { name: "环境", link: "environmental" },
      ],
      chanList: [
        {
          title: [{ name: "工业无线", link: "industrialWir" }],
          detail: [
            { name: "无线网络", link: "" },
            { name: "无线通讯", link: "" },
            { name: "无线位置", link: "" },
            { name: "无线分析", link: "" },
          ],
        },
        {
          title: [{ name: "工业软件", link: "industrialSoft" }],
          detail: [
            { name: "能源管理软件", link: "" },
            { name: "大数据平台", link: "" },
            { name: "GIS地图信息平台", link: "" },
          ],
        },
        {
          title: [{ name: "仪器仪表", link: "measuring" }],
          detail: [
            { name: "流体仪表", link: "" },
            { name: "电力仪表", link: "" },
            { name: "压力仪表", link: "" },
            { name: "温度仪表", link: "" },
            { name: "液位仪表", link: "" },
          ],
        },
      ],
      ziList: [
        {
          title: [{ name: "咨询", link: "consultSer" }],
          detail: [
            { name: "智能工厂咨询服务", link: "intellFactory" },
            { name: "工业物联园区咨询服务", link: "iotPark" },
          ],
        },
        {
          title: [{ name: "服务", link: "servicing" }],
          detail: [
            { name: "设备安装与运维服务", link: "install" },
            { name: "数据分析与校准服务", link: "dataAnalysis" },
            // { name: "能源与能效诊断服务", link: "" },
          ],
        },
      ],
      zhuanList: [
        { name: "综合介绍", link: "" },
        { name: "能源", link: "" },
        { name: "流体计量", link: "" },
        { name: "数据分析与校准服务", link: "" },
      ],
      liaoList: [
        { name: "企业概述", link: "" },
        { name: "企业文化", link: "" },
        { name: "荣誉资质", link: "" },
        { name: "新闻报告", link: "" },
        { name: "合作伙伴", link: "" },
      ],
      jiaList: [
        { name: "社会招聘", link: "" },
        { name: "校园招聘", link: "" },
      ],
      erweima: require("@assets/img/erma.png"),
    };
  },
  components: {},
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
    //  this.$router.afterEach(() => {
    //   window.scrollTo(0, 0)
    // })
  },
  methods: {
    //跳往解决方案二级页面
    handleJieSecond() {
      this.$router.push("/solution");
      this.backtop()
      this.reload();
    },
    //跳往产品中心二级页面
    handleChanSecond() {
      this.$router.push("/productCenter");
       this.backtop()
      this.reload();
    },
    //跳往咨询服务二级页面
    handleZiSecond() {
      this.$router.push("/consulting");
       this.backtop();
      this.reload();
    },
    //跳往专长页面
    handleZhuanSecond() {
      this.$router.push("/expertise");
       this.backtop()
      this.reload();
    },
    //跳往了解我们页面
    handleLiaoSecond() {
      this.$router.push("/knowus");
       this.backtop()
      this.reload();
    },
    // 点专长具体选项
    handleZhuan(index) {
      sessionStorage.setItem("expertise", index);
      this.$router.push({ name: "Expertise", params: { tab: index } });
       this.backtop()
      this.reload();
    },
    // 点击了解我们具体选项
    handleLiao(index) {
      sessionStorage.setItem("knowus", index);
      this.$router.push({ name: "Knowus", params: { tab: index } });
       this.backtop()
      this.reload();
    },
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
        // this.$refs.foot.scrollIntoView();
      // var timer = setInterval(function () {
      //   let osTop =
      //     document.documentElement.scrollTop || document.body.scrollTop;
      //   let ispeed = Math.floor(-osTop / 5);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     osTop + ispeed;
      //   this.isTop = true;
      //   if (osTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 30);
        let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 100;
          document.documentElement.scrollTop -= 100;
        } else {
          clearInterval(back);
        }
      });
    },
     flushCom(){
      // this.$router.go(0);
        this.backtop()
        this.reload();
    },
  },
};
</script>

<style lang='scss' scoped>
.footer {
  // height: 555px !important;
  width: 100%;
  background: rgba(51, 50, 52, 1) !important;
}
.bottom_border {
  width: 100%;
  border-bottom: 1px solid rgba(59, 59, 60, 1);
}
.bottom_center {
  width: 75%;
  // height: 310px;
  margin: 0 auto;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  ul {
    // float: left;
    // margin-right: 183px;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
    li {
      cursor: pointer;
      span {
        cursor: pointer;
      }
      &:nth-child(1) {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(127, 127, 127, 1);
      margin-bottom: 25px;
      .foot_title {
        color: rgba(255, 255, 255, 1) !important;
        cursor: pointer;
      }
    }
  }
}
.contact {
  width: 100%;
  border-bottom: 1px solid rgba(59, 59, 60, 1);
}
.contact_center {
  width: 75%;
  // height: 150px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  position: relative;
  .font {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    // padding-top: 28px;
    padding-bottom: 28px;
    cursor: default;
  }
   .contact_phone {
    img {
      // width: 15px;
      margin-right: 14px;
      display: inline-block;
    }
    span {
      cursor: default;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
    }
  }
  .contact_phone1{
    margin-bottom: 18px;

     display: flex;
        align-items: center;
    img{
      width: 15px;
      height: 18px;
    }
    .phone1{
        margin-right: 58px;
    }
    .chuanzhen{
      // margin-top:3px
    }
  }
  .contact_phone2{
   display: flex;
        align-items: center;
    img{
      width: 15px;
      height: 18px;
    }
    .phone2{
         margin-right: 58px;
    }
    .chuanzhen{
      // margin-top:3px
    }
    .dizhi{
      width: 12px;
      height: 18px;
       margin-right: 17px;
      // margin-right: ;
    }
  }
  .image_er {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .erweima {
    // position: absolute;
    // right: 0;
    // top: 50%;
    width: 87px;
    height: 87px;
  }
}
.power {
  text-align: center;
  padding-bottom: 20px;
  // height: 200px;
  span {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    margin-top: 20px;
    display: inline-block;
  }
}
.zixun1{
 margin-bottom: 25px;
}
.zc{
  letter-spacing:29px
}
</style>
